import { render, staticRenderFns } from "./BackofficeTpl.vue?vue&type=template&id=5867aec4"
import script from "./BackofficeTpl.vue?vue&type=script&lang=js"
export * from "./BackofficeTpl.vue?vue&type=script&lang=js"
import style0 from "./BackofficeTpl.vue?vue&type=style&index=0&id=5867aec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports